import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import { Link } from "react-router-dom";
import "./style.scss";
const Regional = props => {
	const { lang, rendering, fields, page } = props;
  const { title, pcImage, mobileImage, list } = fields;
  const isMobile = mobileIs();
  const isAR = page?.fields?.rtl?.value;

  const rootClasses = classNames("c-regional", isAR ? 'rtl' : '', getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <img src={isMobile ? mobileImage?.value?.src : pcImage?.value?.src} className="c-regional__image" alt="" />
      <div className="c-regional__space">
        <div className="c-regional__space__list">
          {list?.map((item, index) => (
            <div className="c-regional__space__area" key={item.id}>
              <RichText className={'c-regional__space__area__title'} tag="div" field={item.fields.title} />
              <div className={"c-regional__space__area__list"}>
                {item?.fields?.list?.map((el, i) => (
                  <div className={'c-regional__space__area__list__item'} key={el.id}>
                    {el?.fields?.link?.value?.href && el.fields?.link?.value?.linktype === "external" && <a href={el.fields?.link?.value?.href} target={el.fields?.link?.value?.target}>
                      <RichText tag="div" field={el.fields.country} />
                    </a>}
                    {el?.fields?.link?.value?.href && el?.fields?.link?.value?.linktype === "internal" && <Link to={el.fields?.link?.value?.href} className={'c-regional__space__area__list__item'} key={el.id}>
                      <RichText tag="div" field={el?.fields?.country} />
                    </Link>}
                    {!el?.fields?.link?.value?.href && <RichText tag="div" field={el?.fields?.country} />}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <RichText className={'c-regional__space__title'} tag="div" field={title} />
      </div>
    </div>
  );
};

export default 	Regional;